import { Avatar, Chip, Modal } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import React from "react";
import { useNavigate } from "react-router-dom";
import ChipStatus from "./ChipStatus";
import "./ClientCardCompactRedesign.css";
import { getRehabByClient } from "../api/rehabs";

export default function ClientWidgetV2(props) {
  const navigate = useNavigate();
  const showIfEmpty = (value) => {
    return value ? (
      value
    ) : (
      <span className="client-card-missing">
        Not filled
      </span>
    );
  };

  const textValue = (value) => {
    return value ? String(value) : "Not filled";
  };

  const [openModal, setOpenModal] = React.useState(false);
  const hasMobileUid = !!String(props.mobileUid || "").trim();

  const getAgeFromDOB = () => {
    if (!props.dob) {
      return "No birth date";
    }

    const dobDate = props.dob.toDate(); // Convert Firestore timestamp to JavaScript Date
    const diff = Date.now() - dobDate.getTime();
    const ageDate = new Date(diff);

    return Math.abs(ageDate.getUTCFullYear() - 1970);
  };

  const alertCounts = {
    reminders: 0,
    allergies: 0,
    alerts: 0,
  };

  (props.alerts || []).forEach((alert) => {
    switch (
      alert.type // Remplacez "type" par la cl?? correcte pour le type d'alerte
    ) {
      case 1:
        alertCounts.reminders += 1;
        break;
      case 2:
        alertCounts.allergies += 1;
        break;
      case 3:
        alertCounts.alerts += 1;
        break;
      default:
        break;
    }
  });

  const age = getAgeFromDOB();

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleNavigate = () => {
    navigate(`/client/${props.docId}`, {
      state: props,
    });
  };

  const fullName = `${textValue(props.firstnameClient)} ${textValue(
    props.lastnameClient
  )}`;
  const totalAlerts =
    alertCounts.reminders + alertCounts.allergies + alertCounts.alerts;
  const rehab = getRehabByClient(props);
  const rehabCode = rehab?.country === "Philippines" ? "PH" : "TH";

  return (
    <article className="client-card-redesign">
      <span
        className={`client-rehab-badge client-rehab-badge-${rehabCode.toLowerCase()}`}
        title={rehab?.name}
      >
        {rehabCode}
      </span>
      <div className="client-card-header">
        <div className="client-card-header-main">
          <div className="client-card-status">
            <ChipStatus
              status={props.clientStatus || ""}
              rehabId={props.rehabId}
              rehabCountry={props.rehabCountry}
            />
          </div>
          <div className="client-card-name" title={fullName}>
            <span>{showIfEmpty(props.firstnameClient)}</span>
            <span>{showIfEmpty(props.lastnameClient)}</span>
          </div>
          <div className="client-card-subline">
            AKA {showIfEmpty(props.aka)}
            {hasMobileUid && (
              <Chip
                label="Mobile active"
                size="small"
                className="client-card-mobile-chip"
              />
            )}
          </div>
        </div>

        <button
          className="client-card-avatar-button"
          type="button"
          onClick={handleOpenModal}
          aria-label="Open client picture"
        >
          <Avatar
            src={props.profilePic}
            alt={fullName}
            className="client-card-avatar"
          />
        </button>
      </div>

      <div className="client-card-body">
        <div className="client-card-info client-card-info-wide">
          <span>Arrival</span>
          <strong>{showIfEmpty(props.arrivalDate || props.eta)}</strong>
          <em>{showIfEmpty(props.ils)} stay</em>
        </div>

        <div className="client-card-info">
          <span>Therapist</span>
          <strong>{showIfEmpty(props.assignedTherapist)}</strong>
        </div>

        <div className="client-card-info">
          <span>Room</span>
          <strong>{showIfEmpty(props.roomNumber)}</strong>
        </div>

        <div className="client-card-info">
          <span>Age</span>
          <strong>{showIfEmpty(age)}</strong>
        </div>

        <div className="client-card-info">
          <span>Payment</span>
          <strong>{showIfEmpty(props.paymentDetails)}</strong>
        </div>

        <div className="client-card-info">
          <span>Issue</span>
          <strong>{showIfEmpty(props.primaryAddiction)}</strong>
        </div>

        <div className="client-card-info client-card-info-wide">
          <span>Itinerary</span>
          <strong>{showIfEmpty(props.flightDetailsContent)}</strong>
        </div>
      </div>

      {totalAlerts > 0 && (
        <div className="client-card-alerts">
          {alertCounts.reminders > 0 && (
            <span>{alertCounts.reminders} reminder</span>
          )}
          {alertCounts.allergies > 0 && (
            <span>{alertCounts.allergies} allergy</span>
          )}
          {alertCounts.alerts > 0 && <span>{alertCounts.alerts} alert</span>}
        </div>
      )}

      <button
        className="client-card-profile-button"
        type="button"
        onClick={handleNavigate}
      >
        <VisibilityIcon fontSize="small" />
        View profile
      </button>

      <Modal
        open={openModal}
        onClose={handleCloseModal}
        aria-labelledby="modal-image"
        aria-describedby="image-full-size"
      >
        <div
          onClick={handleCloseModal}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            height: "100%",
            position: "absolute",
            top: 0,
            left: 0,
            backgroundColor: "rgba(0, 0, 0, 0.3)",
          }}
        >
          <img
            src={props.profilePic}
            alt={fullName}
            style={{
              maxWidth: "90%",
              maxHeight: "90%",
              objectFit: "contain",
            }}
          />
        </div>
      </Modal>
    </article>
  );
}
